(() => {
  const ROW_SELECTOR = '[data-inline-product-row]';
  const VARIANTS_SELECTOR = '[data-inline-product-variants]';
  const OPTION_SELECTOR = '[data-inline-product-option]';
  const INIT_ATTR = 'data-inline-product-init';

  function initInlineProductRows(root = document) {
    root.querySelectorAll(ROW_SELECTOR).forEach(row => {
      if (row.getAttribute(INIT_ATTR) === 'true') return;
      row.setAttribute(INIT_ATTR, 'true');

      const variantsScript = row.querySelector(VARIANTS_SELECTOR);
      const form = row.querySelector('form');
      if (!variantsScript || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        return;
      }

      const variantInput = form.querySelector('input[name="id"]');
      const submitButton = form.querySelector('[type="submit"]');
      const submitText = submitButton?.querySelector(
        '.product-form__submit-text'
      );
      const optionSelects = Array.from(
        row.querySelectorAll(OPTION_SELECTOR)
      ).sort(
        (a, b) =>
          Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );

      const updateVariant = () => {
        const selectedOptions = optionSelects.map(select => select.value);
        const variant = variants.find(item =>
          item.options.every(
            (option, index) => option === selectedOptions[index]
          )
        );

        if (!variant || !variantInput) return;

        variantInput.value = variant.id;

        if (variant.available) {
          variantInput.removeAttribute('disabled');
          submitButton?.removeAttribute('disabled');
          if (submitText) {
            submitText.textContent =
              window.variantStrings?.addToCart || 'Add to cart';
          }
        } else {
          variantInput.setAttribute('disabled', 'disabled');
          submitButton?.setAttribute('disabled', 'disabled');
          if (submitText) {
            submitText.textContent =
              window.variantStrings?.soldOut || 'Sold out';
          }
        }
      };

      optionSelects.forEach(select => {
        select.addEventListener('change', updateVariant);
      });

      if (optionSelects.length > 0) {
        updateVariant();
      }
    });
  }

  window.theme = window.theme || {};
  window.theme.initInlineProductRows = initInlineProductRows;
})();
